function initCustomSticky() {
  const stickyEl = document.querySelector('custom-sticky');
  const stopEl = document.querySelector('.a2c');

  if (!stickyEl || !stopEl) return;
  if (stickyEl.dataset.customStickyInit === 'true') return;
  stickyEl.dataset.customStickyInit = 'true';

  const showSticky = () => {
    stickyEl.style.opacity = '1';
    stickyEl.style.pointerEvents = 'auto';
    stickyEl.removeAttribute('inert');
    if (window.updateTidioForStickies) {
      window.updateTidioForStickies();
    }
    if (window.revealTidioPdpChat) {
      setTimeout(() => {
        window.revealTidioPdpChat();
      }, 120);
    }
  };

  const hideSticky = () => {
    stickyEl.style.opacity = '0';
    stickyEl.style.pointerEvents = 'none';
    stickyEl.setAttribute('inert', '');
    if (window.updateTidioForStickies) {
      window.updateTidioForStickies();
    }
    if (window.revealTidioPdpChat) {
      setTimeout(() => {
        window.revealTidioPdpChat();
      }, 120);
    }
  };

  const syncSticky = () => {
    const stopRect = stopEl.getBoundingClientRect();
    const regularButtonIsReached = stopRect.top < window.innerHeight;

    if (regularButtonIsReached) {
      hideSticky();
    } else {
      showSticky();
    }
  };

  syncSticky();
  window.addEventListener('scroll', syncSticky, { passive: true });
  window.addEventListener('resize', syncSticky, { passive: true });
  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(syncSticky);
    resizeObserver.observe(document.documentElement);
    if (stopEl.parentElement) resizeObserver.observe(stopEl.parentElement);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomSticky);
} else {
  initCustomSticky();
}
